import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const FormField = ({
  label,
  required = false,
  value,
  onChange,
  onBlur,
  placeholder = '',
  type = 'text',
  className = '',
  error = '',
  showError = false,
  digitsOnly = false,
  disabled = false,
  ...rest
}) => {
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (digitsOnly) {
      // Only allow digits (0-9)
      newValue = newValue.replace(/[^0-9]/g, '');
    }
    onChange(newValue);
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <Label className={`text-sm font-bold flex items-center gap-0.5 ${disabled ? 'text-muted-foreground/60' : 'text-foreground'}`}>
        {label}
        {required && <span className={disabled ? 'text-muted-foreground/60 ml-0.5' : 'text-destructive ml-0.5'}>*</span>}
      </Label>
      <Input
        type={type}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        inputMode={digitsOnly ? 'numeric' : undefined}
        {...rest}
        className={`h-11 px-4 border-input transition-colors duration-200 ${
          disabled
            ? 'bg-muted/60 text-muted-foreground/70 placeholder:text-muted-foreground/50 border-muted cursor-not-allowed'
            : showError && error
              ? 'border-2 border-destructive bg-red-50 focus-visible:ring-destructive focus-visible:border-destructive'
              : 'bg-background hover:border-muted-foreground/50 focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-0 focus-visible:border-accent'
        }`}
      />
      {showError && error && (
        <p className="text-sm text-destructive flex items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export { FormField };
export default FormField;
